<template>
  <div class="product">
    <div class="big-title">
      <h2>AI落地方案咨询</h2>
      <p>
        一匠为客户提供专业知识和创新技术，助力客户数字化转型
      </p>
    </div>
    <div class="middle-box">
      <div class="half">
        <p>
          技术的演进永无止境，创新的洞见至关重要。一匠致力于为客户量身定制转型战路，结合AI技术对客户当前所面临的业务难题提供适用的技术解决方案。
        </p>
        <p>
          一匠技术咨询服务借助领先AI技术、设计思维和敏捷方法帮助企业实现业务转型，以适用客户持续为既有系统提供澎解动力。
        </p>
        <div class="btn" @click="showPopup">免费咨询</div>
      </div>
      <img src="../../static/images/7mouth/aizixun.png" />
    </div>
    <div class="big-title">
      <h2>软件研发</h2>
      <p>
        一匠为企业提供值得信赖的互联网技术服务<br/>
（一匠提供应用软件开发与企业信息化建设服务，将IT与业务需求统一起来，能够帮助客户实现商业成功）
      </p>
    </div>
    <div class="reason">
      <div class="item" v-for="item in reasonList" :key="item.id">
        <img :src="item.img" />
        <h2>{{ item.title }}</h2>
        <p>
          {{ item.desc }}
        </p>
      </div>
    </div>
    <homepopup :show="show" @close="close"></homepopup>
  </div>
</template>
<script>
import homepopup from "@/components/pc/homepopup";
export default {
  components:{
      homepopup
  },
  data() {
    return {
      show:false,
      reasonList: [
        {
          id: 0,
          img: require("../../static/images/7mouth/wulianwang.png"),
          title: "物联网&智能软硬定制",
          desc:
            "逻辑思维智能软硬件定制开发已对接众多智能硬件设备项目，实时高效的信息数字化服务，包括农业、医疗、新能源、家居、共享、运动健康等方面。",
        },
        {
          id: 1,
          img: require("../../static/images/7mouth/APP.png"),
          title: "APP定制",
          desc:
            "专注高端app开发，高效的技术框架，流畅快速的网页体验，自主研发的代码积累，科学管理流程，4大服务保障体系，让您开发无忧。",
        },
        {
          id: 2,
          img: require("../../static/images/7mouth/web.png"),
          title: "Web系统定制",
          desc:
            "丰富的系统架构经验，提供高并发、高可靠性、安全性系统解决方案，助力众多企业解决系统瓶颈，快速抢占市场先机。",
        },
        {
          id: 3,
          img: require("../../static/images/7mouth/xiaochengxu.png"),
          title: "微信小程序定制",
          desc:
            "小程序跨平台的属性，使开发和维护成本更低，开发速度更快。无缝对接微信、APP。逻辑思维软件丰富的开发经验，快速打造企业专属小程序。",
        },
        {
          id: 4,
          img: require("../../static/images/7mouth/aidingzhi.png"),
          title: "AI方案定制",
          desc:
            "依托大模型与机器学习技术，为企业提供从需求分析到落地部署的全流程 AI 定制服务，覆盖智能客服、数据预测等场景，助力企业降本增效、实现业务智能化升级。",
        },
        {
          id: 5,
          img: require("../../static/images/7mouth/qiye.png"),
          title: "企业系统定制",
          desc:
            "定制属于企业的个性化管理软件，解决销售无计划、进度无把控、客户无管理、信息无反馈、业绩无考核等问题。",
        },
      ],
    };
  },
  methods: {
	  close(){
		  this.show = false;
	  },
    showPopup(){
      this.show = true;
    },
    jumpPages(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style lang="stylus" scoped>
.product {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  padding: 80px 0;

  .big-title {
    h2 {
      text-align: center;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }

    p {
      margin: 24px 0 60px 0;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
    }
  }

  .middle-box {
    width: 1280px;
    display: flex;
    align-items: center;
    position: relative;

    .half {
      width: 555px;
      position: absolute;

      p {
        display: block;
        width: 100%;
        margin: 10px 0 50px 0;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 32px;
      }

      .btn {
        margin-top: 60px;
      }
    }

    img {
      margin-left: 200px;
      width: 1079px;
      height: 421px;
    }
  }

  .btn {
    line-height: 40px;
    text-align: center;
    width: 100px;
    height: 40px;
    background: #FFC000;
    border-radius: 4px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
  }

  .separate-line {
    width: 1400px;
    height: 1px;
    background: #EEEEEE;
  }

  .reason {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    width: 1620px;

    .item {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-top: 12px;
      width: 451px;
      height: 268px;
      background: #FFFFFF;
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
      border-radius: 4px;
      margin: 0 24px 24px 0;
      transition: all .4s;

      img {
        width: 58px;
        height: 58px;
      }

      h2 {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin: 16px 0 30px;
      }

      p {
        width: 370px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #666666;
        line-height: 30px;
        text-align: center;
      }
    }

    .item:hover {
      box-shadow: 0px 5px 17px 3px rgba(230, 192, 76, 0.15);
      transform:scale(1.07, 1.07);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/HomeProduct.vue